import { IdentityPlatform, LoginProfile, PlayerJoinState } from '@playcastdotio/CoreTypes';
import { Invitation, UserEventType, UserOwnedLobbiesData, UserSessionTrackingData } from '@playcastdotio/Messaging';
import { LatencyResults, BandwidthResult } from '@playcastdotio/PingClient';
import { makeStateStore } from '@playcastdotio/StateStore';

export const authStore = makeStateStore({
  accessToken: '',
  email: '',
  playerAuthId: '',
  expiresAt: 0,
  loaded: false as boolean,
});

const initialJoinState: PlayerJoinState = {
  state: 'idle',
  platform: IdentityPlatform.CLERK,
};
export const joinState = makeStateStore<PlayerJoinState>(initialJoinState);

export const observedInvitationState = makeStateStore<Invitation | null>(null);

const initialLoginProfileState: LoginProfile = {
  email: '',
  firstName: '',
  lastName: '',
  name: '',
  picture: '',
  phoneNumber: '',
  hostAuthId: '',
  accessToken: '',
  expiresAt: 0,
};
export const loginProfileState = makeStateStore<LoginProfile>(initialLoginProfileState);

type AutoJoinState = {
  isAttempting: boolean;
  invitationId: string | null;
  timestamp: number;
  retryAttempted?: boolean;
};

const initialAutoJoinState: AutoJoinState = {
  isAttempting: false,
  invitationId: null,
  timestamp: 0,
};
export const autoJoinState = makeStateStore(initialAutoJoinState);

type UserEventsState = {
  isLoading: boolean;
  lastFetched: number;
  mailingListSubscribed: boolean;
  betaFlagOptedIn: boolean;
  sessionTracking: UserSessionTrackingData | null;
  ownedLobbies: string[] | null;
};

const initialUserEventsState: UserEventsState = {
  isLoading: false,
  lastFetched: 0,
  mailingListSubscribed: false,
  betaFlagOptedIn: false,
  sessionTracking: null,
  ownedLobbies: null,
};
export const userEventsState = makeStateStore(initialUserEventsState);

type NetworkMetricsState = {
  ping: LatencyResults;
  bandwidth: BandwidthResult;
};

const initialNetworkMetricsState: NetworkMetricsState = {
  ping: {},
  bandwidth: {
    downloadSizeBytes: 0,
    uploadSizeBytes: 0,
    downloadSpeedKbps: 0,
    uploadSpeedKbps: 0,
    downloadTimeMs: 0,
    uploadTimeMs: 0,
    downloadSpeedBits: 0,
    uploadSpeedBits: 0,
  },
};
export const networkMetricsState = makeStateStore(initialNetworkMetricsState);

type RegionOverrideState = {
  regionOverride: 'auto' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2' | 'auto' | undefined;
};

const initialRegionOverrideState: RegionOverrideState = {
  regionOverride: (localStorage.getItem('regionOverride') as RegionOverrideState['regionOverride']) || undefined,
};
export const regionOverrideState = makeStateStore(initialRegionOverrideState);
regionOverrideState.addListener((state) => {
  localStorage.setItem('regionOverride', state.regionOverride || '');
});
